<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- 商家後台佈局 -->
      <StoreLayout v-if="isStoreLayout">
        <router-view/>
      </StoreLayout>
      <!-- 一般佈局 -->
      <div v-else>
        <router-view/>
      </div>
    </transition>
    <Toast 
      :show="toast.show" 
      :message="toast.message" 
      :type="toast.type"
    />
  </div>
</template>

<script>
import Toast from './components/Toast.vue'
import StoreLayout from './layouts/StoreLayout.vue'

export default {
  name: 'App',
  components: {
    Toast,
    StoreLayout
  },
  data() {
    return {
      toast: {
        show: false,
        message: '',
        type: 'success'
      }
    }
  },
  computed: {
    isStoreLayout() {
      return this.$route.meta && this.$route.meta.layout === 'StoreLayout'
    }
  },
  created() {
    // 使用事件總線監聽
    this.$eventBus.$on('show-toast', this.showToast)
    
    // 初始化購物車
    this.$store.dispatch('initCart')
    
    // 監聽登入狀態變化
    this.$store.watch(
      (state) => state.token,
      (newToken, oldToken) => {
        // 當 token 從無到有時，重新初始化購物車
        if (newToken && !oldToken) {
          this.$store.dispatch('initCart')
        }
      }
    )
  },
  beforeDestroy() {
    // 清理事件監聽器
    this.$eventBus.$off('show-toast', this.showToast)
  },
  methods: {
    showToast({ message, type = 'success', duration = 2000 }) {
      this.toast = {
        show: true,
        message,
        type
      }
      
      if (type === 'loading') {
        return
      }
      
      setTimeout(() => {
        this.toast.show = false
      }, duration)
    }
  },
  metaInfo() {
    return {
      titleTemplate: '%s - 購物平台',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: '專業購物平台，提供優質商品和服務' },
        { name: 'keywords', content: '購物,網購,商品,服務,線上購物' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: '購物平台' },
        { name: 'twitter:card', content: 'summary' }
      ]
    }
  }
}
</script>

<style>
@import './assets/css/style.css';

/* 過渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

/* 確保過渡效果在路由切換前完成 */
.fade-leave-active {
  position: absolute;
  width: 100%;
}
</style> 